export const defaultMinDate = new Date(1900, 0, 1, 0, 0, 0);
export const defaultMaxDate = new Date(2099, 11, 31, 0, 0, 0);
